export const AM = `AM`;

export const PM = `PM`;

export const ADAK = `America/Adak`;

export const ANCHORAGE = `America/Anchorage`;

export const CHICAGO = `America/Chicago`;

export const DENVER = `America/Denver`;

export const LOS_ANGELES = `America/Los_Angeles`;

export const NEW_YORK = `America/New_York`;

export const PHOENIX = `America/Phoenix`;

export const HONOLULU = `Pacific/Honolulu`;

export const AKST = `Alaska Standard Time (AKST)`;

export const CST = `Central Standard Time (CST)`;

export const MST = `Mountain Standard Time (MST)`;

export const EST = `Eastern Standard Time (EST)`;

export const HST = `Standard Time (HST)`;

export const PST = `Pacific Standard Time (PST)`;

export const AKDT = `Alaska Daylight Time (AKDT)`;

export const MDT = `Mountain Daylight Time (MDT)`;

export const PDT = `Pacific Daylight Time (PDT)`;

export const EDT = `Eastern Daylight Time (EDT)`;

export const TIMEZONES = {
  [ADAK]: AKST,
  [ANCHORAGE]: AKST,
  [CHICAGO]: CST,
  [DENVER]: MST,
  [LOS_ANGELES]: PST,
  [NEW_YORK]: EST,
  [PHOENIX]: MST,
  [HONOLULU]: HST,
} as const;

export const TIMEZONES_DST = {
  [ADAK]: AKDT,
  [ANCHORAGE]: AKDT,
  [CHICAGO]: CST,
  [DENVER]: MDT,
  [LOS_ANGELES]: PDT,
  [NEW_YORK]: EDT,
  [PHOENIX]: MDT,
  [HONOLULU]: HST,
} as const;
